import { Hub } from '../places/hub/hub';
import { EboTenantItem } from './ebo-tenant-item';

export class EboTenantHubObject extends EboTenantItem {
  hubID: number;
  hub: Hub;

  constructor(jsonData?: Partial<EboTenantHubObject>) {
    // console.log('TenantObject call parent')
    super(jsonData);
    // console.log('TenantObject local')
    if (jsonData) {
      if (jsonData.hub) {
        this.hub = new Hub(jsonData.hub);
      }
    }
  }
}
